import React from "react";

export const PremiumCard = ({
  title,
  subtitle,
  actions,
  footer,
  flush = false,
  hover = false,
  flat = false,
  sunken = false,
  className = "",
  bodyClassName = "",
  children,
  ...rest
}) => {
  const cls = [
    "pc-card",
    hover && "pc-card--hover",
    flat && "pc-card--flat",
    sunken && "pc-card--sunken",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const hasHead = title || subtitle || actions;
  const bodyCls = `pc-card__body ${flush ? "pc-card__body--flush" : ""} ${bodyClassName}`.trim();

  return (
    <div className={cls} {...rest}>
      {hasHead && (
        <div className="pc-card__head">
          <div>
            {title && <h3 className="pc-card__title">{title}</h3>}
            {subtitle && <p className="pc-card__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="pc-card__actions">{actions}</div>}
        </div>
      )}
      <div className={bodyCls}>{children}</div>
      {footer && <div className="pc-card__foot">{footer}</div>}
    </div>
  );
};

export default PremiumCard;
